import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  TextInput,
} from "react-native";
import { FontAwesome5 } from "@expo/vector-icons";
const { width, height } = Dimensions.get("window");
export default function inputdate(
  placeholder,
  onChangeText,
  type,
  locate,
  setLo,
  setHandelCalendar,
  value,
  date,
  placeholder1,
  onChangeText1,
  type1,
  locate1,
  setLo1,
  setHandelCalendar1,
  value1,
  onPress
) {
  return (
    <View>
      <TextInput
        style={styles.input}
        placeholder={placeholder}
        onChangeText={onChangeText}
        type={type}
        locate={locate}
        setLo={setLo}
        setHandelCalendar={setHandelCalendar}
        value={value}
        placeholder={placeholder1}
        onChangeText={onChangeText1}
        type={type1}
        locate={locate1}
        setLo={setLo1}
        setHandelCalendar={setHandelCalendar1}
        value={value1}
      />
      <TouchableOpacity onPress={onPress} style={styles.botton1}>
        {date == "show" && (
          <FontAwesome5 name="calendar-alt" size={18} color="#AFAFAF" />
        )}
      </TouchableOpacity>
      <TouchableOpacity onPress={onPress} style={styles.botton1}>
        {date == "show1" && (
          <FontAwesome5 name="calendar-alt" size={18} color="#AFAFAF" />
        )}
      </TouchableOpacity>
    </View>
  );
}
const styles = StyleSheet.create({
  input: {
    width: width * 0.18,
    height: 30,
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#D9D9D9",
    paddingLeft: 25,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  botton1: {
    position: "absolute",
    alignSelf: "flex-end",
    padding: 5,
    zIndex: 999,
  },
});
